import styled from 'styled-components';
import { Card as CustomCard } from 'shared/theme/elements';

export const Card = styled(CustomCard)`
  display: flex;
  justify-content: center;
  align-items: center;
`;
